module.exports = __webpack_public_path__ + "static/img/sarpa-new-logo.de86922.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sarpa-new-logo.png
// module id = eVJd
// module chunks = 1